
define('modules/application/wizard/steps/zoneStep/thermoZoneStep/zoneDetailView',[
    "app",

    // Libs
    "backbone",
    "jqueryUi",

    // Classes
    "../zoneDetailView",
    "../../../classes/solenoidValves",
    "../../../classes/probes",
    "../../../classes/ecoMode",
    //Widgets
    "../../../../widgets/consumptionIndicator"
  ],

  function(
    app,
    Backbone,
    jQueryUi,
    ZoneDetailView,
    solenoidValves,
    probes,
    ecoMode,
    consumptionIndicator) {

    //Creating a single zone model
    var thermoZoneDetailView = ZoneDetailView.extend({

      initialize: function() {
        ZoneDetailView.prototype.initialize.apply(this);
        this.consumptionIndicator = consumptionIndicator;
      },

      sectionInstancer: function(section) {
        switch (section.name) {
          case "solenoidValves":
            return solenoidValves;
          case "probes":
            return probes;
          case "ecoMode":
            return ecoMode;
        }
      },

      beforeRender: function() {

        //Consumption indicator insertion
        //Adding current consumption indicator
        if (BticinoS4B.Instances.Models.ApplicationModel.get("consumptionIndicatorModel"))
          consumptionIndicatorModel = BticinoS4B.Instances.Models.ApplicationModel.get("consumptionIndicatorModel");
        else
          consumptionIndicatorModel = new this.consumptionIndicator.Model();

        //this.insertView(".indicators", new consumptionIndicator.View({model: consumptionIndicatorModel}));

      }

    });

    // Required, return the module for AMD compliance
    return thermoZoneDetailView;
  });